import React, { useMemo, useEffect } from 'react';
import "./Votes.css";
import { useApi } from '../../hooks/useApi';
import { UserAuth } from '../../context/AuthContext';
import BallotTable from './BallotTable/BallotTable';
import LoadingCircle from '../../components/Global/LoadingCircle';
import config from '../../config';
import Attendance from './Attendance/Attendance';
import useSSE from '../../utils/useSSE';
export default function Votes() {
    const { user } = UserAuth();
    const { api } = useApi();
    const [ballots, setBallots] = React.useState({ open: [], closed: [] });
    const [loadingBallots, setLoadingBallots] = React.useState(true);

    const filteredBallots = useMemo(() => ({
        open: ballots.open,
        closed: ballots.closed
    }), [ballots.open, ballots.closed]);

    const processBallotData = (data) => {
        const { open, closed } = data.reduce((acc, ballot) => {
            if (ballot.closed_at === null) {
                acc.open.push(ballot);
            } else {
                acc.closed.push(ballot);
            }
            return acc;
        }, { open: [], closed: [] });

        setBallots({ open, closed });
    };

    const updateBallotVoteCount = (ballotId) => {
        setBallots(prev => {
            const openBallotExists = prev.open.some(ballot => ballot.id === ballotId);
            if (!openBallotExists) {
                console.log("Ballot doesn't exist in state:", ballotId);
                return prev;
            }
    
            return {
            open: prev.open.map(ballot => 
                ballot.id === ballotId 
                        ? { ...ballot, voters: (ballot.voters || 0) + 1, inherit_voters: (ballot.inherit_voters || 0) + 1 }
                    : ballot
            ),
                closed: prev.closed
            };
        });
    };

    useEffect(() => {
        if (user) {
            
            const ballotData = async () => {
                setLoadingBallots(true);
                try {
                    if (user.accessToken === undefined) return;

                    const result = await api("ballot/votable", "GET");
                    processBallotData(result);
                } catch (error) {
                    console.error("Error fetching ballots:", error);
                } finally {
                    setLoadingBallots(false);
                }
            };
            ballotData();
        }
    }, [user]);

    useSSE(
        'stream/global',
        user?.accessToken,
        (message) => {
            console.log('Received SSE message:', message);
            try {
                switch (message.type) {
                    case 'ballot_created':
                        setBallots(prev => ({
                            ...prev,
                            open: [message.data, ...prev.open]
                        }));
                        break;

                    case 'ballot_closed':
                        console.log('Ballot closed message data:', message.data);
                        const closedBallot = {
                            ...message.data,
                            id: message.data.id,
                            title: message.data.title,
                            parent_id: message.data.parentBallotId || message.data.parent_id || null,
                            inherit_voters: message.data.inherit_voters || message.data.voters || 0,
                            closed_at: message.data.closedAt || message.data.closed_at
                        };
                        setBallots(prev => ({
                            open: prev.open.filter(b => b.id !== message.data.id && b.id !== message.data.juniorBallotId && b.id !== message.data.alumniBallotId),
                            closed: [closedBallot, ...prev.closed]
                        }));
                        break;

                    case 'ballot_archived':
                        setBallots(prev => ({
                            open: prev.open.filter(b => b.id !== message.data.id),
                            closed: prev.closed.filter(b => b.id !== message.data.id)
                        }));
                        break;

                    case 'vote':
                        updateBallotVoteCount(message.data.ballotId);
                        break;
                }
            } catch (error) {
                console.error("Error processing SSE data:", error);
            }
        },
        (error, isVisibleError) => {
            if (isVisibleError) {
                console.error("SSE Connection Error:", error);
            }
        }
    );

    return (
        <div>
            <div>
                <Attendance user={user}/>
               {loadingBallots ? 
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                        <LoadingCircle />
                    </div> : 
                    <> 
                        <BallotTable ballots={filteredBallots.open} title="Voturi Deschise" type="opened" />
                        <BallotTable ballots={filteredBallots.closed} title="Voturi Închise Recent" type="closed" /> 
                    </>
                }
            </div>
        </div>
    );
}